import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePostRewardCenterHistoryMutation } from '../../../state/query/rewardCenter';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import ERROR_CODE from '../../../utils/errorCodes';
import Logger from '../../../lib/analytics/logger';
import audio from '../../../utils/audio';

var useRewardCenterHistory = function useRewardCenterHistory() {
  var _usePostRewardCenterH = usePostRewardCenterHistoryMutation(),
      _usePostRewardCenterH2 = _slicedToArray(_usePostRewardCenterH, 2),
      postRewardCenterHistory = _usePostRewardCenterH2[0],
      isLoading = _usePostRewardCenterH2[1].isLoading;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      history = _useState2[0],
      setHistory = _useState2[1];

  var rewardCenterBaseUrl = useSelector(function (state) {
    return state.app.assetsUrls.RewardsImageBaseURL;
  });
  var getOfferHistory = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            audio.onClick();
            _context.prev = 1;
            _context.t0 = setHistory;
            _context.next = 5;
            return postRewardCenterHistory({
              rewardCenterBaseUrl: rewardCenterBaseUrl
            });

          case 5:
            _context.t1 = _context.sent.data;
            (0, _context.t0)(_context.t1);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t2 = _context["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context.t2, Object.getOwnPropertyNames(_context.t2)),
              code: ERROR_CODE.GET_REWARD_HISTORY_REQUEST_ERROR
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  })), [postRewardCenterHistory, rewardCenterBaseUrl]);
  useEffect(function () {
    getOfferHistory();
  }, [getOfferHistory]);
  return {
    isLoading: isLoading,
    history: history
  };
};

export default useRewardCenterHistory;